import { MainKeys } from '../../../main/main.key';
import { Places } from '../../../route-consts';
/**
 * Como excluir a conta pelo app.
 *
 * Publica e sem parametro. Existe porque as lojas de aplicativo exigem um endereco
 * publico que explique a exclusao de conta - e por isso ela e alcancada de fora,
 * por link, e nao pelo menu.
 */
export class AppDeleteAccountKeys extends MainKeys {
    get place() {
        return Places.appDeleteAccount;
    }
}
//# sourceMappingURL=app-delete-account.key.js.map